import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryImages = [
    {
      url: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/9098b0197ab9282a8da29874a056df72.jpeg'
    },
    {
      url: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/8f8657b0dc4cbd230cf00e84c53c5e34.jpeg'
    },
    {
      url: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/5e886124ec2890c4982aae989c57cf36.jpeg'
    },
    {
      url: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/5ae16195a2cbe00749b93350c203365f.jpeg'
    },
    {
      url: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/de9fa432b9fd065e51412c2fb625f774.png'
    },
    {
      url: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/00374d741e47b25866a3507ae7ee5833.jpeg'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Gallery
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore moments captured from our sailing adventures, training sessions, and racing competitions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
              onClick={() => setSelectedImage(image.url)}
            >
              <div className="relative h-72 w-full">
                <img
                  src={image.url}
                  alt="Gallery"
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-gray-300 transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-4xl"></i>
          </button>
          <img
            src={selectedImage}
            alt="Gallery"
            className="max-w-full max-h-full object-contain rounded-lg"
          />
        </div>
      )}
    </section>
  );
}
